import styled from "styled-components";
import LogoIcon from "../../assets/images/gli-GIF 1.webp";
import LeftIcon from "../../assets/icons/blackLeft.svg";

type Show = {
  show: boolean;
};
export const NavbarContainer = styled.nav`
  padding: 0.7rem 0;
  display: flex;
  backdrop-filter: blur(15px);
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 99;
  max-width: 1600px;
  width: calc(100% - 4rem);
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;
export const Bar = styled.div`
  position: fixed;
  width: 100%;
  height: 1px;
  left: 0;
  top: 87px;
  background: ${({ theme: { colors } }) => colors.gray200};
`;
export const Logo = styled.img.attrs({ src: LogoIcon })`
  width: 65px;
  height: 65px;
`;
export const SearchContainer = styled.div<Show>`
  width: 44%;
  display: flex;
  gap: 1rem;
  opacity: 1 !important;
  pointer-events: all !important;
  @media (max-width: 860px) {
    position: fixed;
    display: flex;
    align-items: center;
    background-color: ${({ theme: { colors } }) => colors.primaryLight};
    width: 100%;
    height: 87px;
    right: ${({ show }) => (show ? "0" : "50%")};
    top: 0;
    transition:
      right 400ms cubic-bezier(0.87, 0, 0.13, 1) 0s,
      opacity 400ms cubic-bezier(0.87, 0, 0.13, 1);
    opacity: ${({ show }) => (show ? "1" : "0")} !important;
    pointer-events: ${({ show }) => (show ? "all" : "none")} !important;
    z-index: 100;
  }
`;
export const AddButton = styled.button`
  display: grid;
  place-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ theme: { colors } }) => colors.gray300};
  @media (max-width: 860px) {
    display: none;
  }
`;
export const MobileIcon = styled.div`
  display: none;
  @media (max-width: 860px) {
    display: flex;
  }
`;
export const BackIcon = styled.img.attrs({ src: LeftIcon })`
  body[dir="rtl"] & {
    transform: rotate(180deg);
  }
  cursor: pointer;
`;
export const ProfileIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #2d2f31;
  color: ${({ theme: { colors } }) => colors.white};
  display: grid;
  place-content: center;
  cursor: pointer;
`;
